// @ts-nocheck
/**
 * DashboardPage — routes traffic to one of two entirely different UIs:
 *
 *   1. CALL_CENTRE_AGENT → AgentPortalPage (the /cti2 rebuild of the
 *      full-screen agent workspace, promoted here as the agent's real
 *      post-login destination — replaces the old CTIAgentUI). Agents
 *      don't get the widget grid; their whole dashboard is the
 *      call-handling shell. AgentPortalPage owns its own socket
 *      lifecycle (useSocket/useMobileCallSocket) internally, since it
 *      was built to also work standalone at the /cti2 route — nothing
 *      extra is wired up here.
 *
 *   2. Everyone else → DashboardShell, the obd3-gui-v1-style widget
 *      grid with per-user layouts, drag-to-reorder, size cycler, and
 *      the Add-widget slide-over library.
 *
 * All the shared state that a couple of widgets need (date range,
 * portal-report bootstrap, agent-status polling) lives in
 * DashboardDataContext, hoisted from the legacy DashboardPage's inline
 * state so behavior stays byte-identical to v1.
 */
import { memo, useState } from 'react';
import { getUser } from '@/utilities/setting';
import { USER_ROLES } from '@/utilities/constant';
import AgentPortalPage from '@/features/cti2/AgentPortalPage';
import { DashboardDataProvider } from './DashboardDataContext';
import { DashboardShell } from './components/DashboardShell';

export const DashboardPage = memo(function DashboardPage() {
  const [loggedInUserRole] = useState<string | null>(() => getUser()?.role ?? null);

  const isAgent = loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT;

  if (isAgent) {
    return <AgentPortalPage />;
  }

  return (
    <DashboardDataProvider>
      <DashboardShell />
    </DashboardDataProvider>
  );
});

export default DashboardPage;
